import { morph } from '@theme/morph';
import { ThemeEvents } from '@theme/events';

/**
 * Re-renders the Dynamic Benefit List when another variant is selected.
 * The list comes from a variant metafield holding metaobjects, which the
 * variantUpdate event payload does not carry — so we re-fetch the section,
 * the same approach local-pickup.js uses.
 */
class VariantBenefitList extends HTMLElement {
  /** @type {AbortController | undefined} */
  #activeFetch;
  /** @type {Element | null} */
  #section = null;

  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  /** @param {import('./events').VariantUpdateEvent} event */
  #onVariantUpdate = (event) => {
    const variantId = event.detail.resource?.id;
    if (!variantId || String(variantId) === this.dataset.variantId) return;

    if (event.detail.data.newProduct) this.dataset.productUrl = event.detail.data.newProduct.url;
    this.dataset.variantId = String(variantId);

    this.#activeFetch?.abort();
    const abortController = new AbortController();
    this.#activeFetch = abortController;

    fetch(`${this.dataset.productUrl}?variant=${variantId}&section_id=${this.dataset.sectionId}`, {
      signal: abortController.signal,
    })
      .then((response) => response.text())
      .then((text) => {
        if (abortController.signal.aborted) return;
        const html = new DOMParser().parseFromString(text, 'text/html');
        const next = html.querySelector(`variant-benefit-list[data-block-id="${this.dataset.blockId}"]`);
        // ponytail: no next element means the section markup changed — leave the current list alone.
        if (next) morph(this, next);
      })
      .catch(() => {});
  };
}

if (!customElements.get('variant-benefit-list')) {
  customElements.define('variant-benefit-list', VariantBenefitList);
}
